
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Modal {

    class MenuModalController {

        static $inject = [
            "$mdDialog",
            "$sce",
            "url" ];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            public $sce: ng.ISCEService,
            public url: string

        ) {

        }
        trustHtml() {
            return this.$sce.trustAsResourceUrl(this.url);

        }   

        modalCancel = () => {
            this.$mdDialog.hide(false);
        };  
    }

    angular.module("meevo.components.modal")
        .controller("meevo.components.modal.MenuModalController", MenuModalController);
}